export const HEADER_GRID_CLASSNAME =
  'grid grid-cols-[auto_minmax(360px,auto)] items-center gap-x-6 gap-y-1';
